import env from "../../utils/env";

let SurveyService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("survey/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },       
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "jugglerId",
          fields: {
            "responseDate": { editable: false },            
            "fullName": {},            
            "jugglerId": {},
            "email": {},
            "jugglerType": {},
            "interestInHomeAgedCareResponse": {},
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  return { getDataSource };
}

function _getResourceLocation(options) {
  return env.getApiUrl(`survey/${options.id}`);
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if(type == "read") {
    let filters = [];

    if (data.filter) filters = data.filter.filters;

    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;

    console.log("Query::", query)

    return JSON.stringify(query);
  }

  if(type == "update") {
    return JSON.stringify(data);
  }
}

export default SurveyService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/survey.service.js
 **/